import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MedicoAtivoTotalUfResponse } from '@/core/api/sicom-api/registro/medico/controle-administrativo/medico-ativo-total-uf.model';
import { MedicoControleAdministrativoService } from '@/core/api/sicom-api/registro/medico/controle-administrativo/medico-controle-administrativo.service';
import { CustomService } from '@/shared/services/custom.service';

@Injectable({ providedIn: 'root' })
export class MedicoAtivoService extends CustomService {
    constructor(private core: MedicoControleAdministrativoService) {
        super();
    }

    consultarTotalMedicosAtivosPorUf(): Observable<MedicoAtivoTotalUfResponse[]> {
        return this.core.consultarTotalMedicosAtivosPorUf().pipe(catchError(this.handleError));
    }
}
